import { render, staticRenderFns } from "./FamilyHistoryContinuedCN.vue?vue&type=template&id=71fcd196"
import script from "./FamilyHistoryContinuedCN.vue?vue&type=script&lang=js"
export * from "./FamilyHistoryContinuedCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports